import axios from "axios";

const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  // withCredentials: true, // ehtiyac olsa açarsan
});

export default http;
